function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "card"
}, React.createElement("rect", {
  x: 15.102,
  y: 81.62,
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  width: 463.477,
  height: 52.497
}), React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 20,
  strokeMiterlimit: 10,
  d: "M466.771,41.122H26.911 c-6.522,0-11.809,5.373-11.809,12v190.489c0,6.627,5.287,12,11.809,12h148.53l-46.791-15.44l30.293-91.805L474.641,252.54 c2.412-2.197,3.938-5.378,3.938-8.929V53.122C478.579,46.495,473.292,41.122,466.771,41.122z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "rear-bill-full",
  display: "none"
}, React.createElement("g", {
  display: "inline"
}, React.createElement("rect", {
  x: 128.777,
  y: 197.612,
  transform: "matrix(0.9496 0.3134 -0.3134 0.9496 98.5753 -79.6457)",
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 20,
  strokeMiterlimit: 10,
  width: 336.558,
  height: 138.443
}), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M319.457,215.643c-29.63-9.776-61.575,6.317-71.353,35.946c-9.776,29.629,6.317,61.575,35.945,71.353 c29.631,9.777,61.576-6.317,71.354-35.946C365.181,257.365,349.087,225.42,319.457,215.643z M321.725,261.071l-10.096-3.331 c1.598-4.841,1.018-7.716-1.736-8.625c-2.834-0.936-4.699-0.045-5.594,2.671c-0.637,1.929,0.236,4.704,2.619,8.326l2.41,3.807 l3.947,5.296c3.738,5.336,3.607,14.064-0.393,26.185c-4.143,12.556-10.365,17.462-18.67,14.722l-1.732,5.254l-5.844-1.929 l2.395-7.26c-0.658-1.047-1.068-2.252-1.23-3.614l-1.148,3.483l-10.094-3.331l9.641-29.221l10.096,3.331 c-2.131,6.454-1.504,10.238,1.883,11.355c3.029,1,5.18-0.428,6.453-4.285c1.182-3.58,0.115-7.424-3.199-11.529l-2.939-3.588 c-5.592-6.994-6.654-15.746-3.186-26.254c4.285-12.986,10.422-18.162,18.412-15.525l1.693-5.137l5.844,1.929l-2.064,6.258 c0.357,1.034,0.49,2.214,0.404,3.537l1.014-3.069l10.094,3.331L321.725,261.071z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  d: "M319.457,215.643c-29.63-9.776-61.575,6.317-71.353,35.946 c-9.776,29.629,6.317,61.575,35.945,71.353c29.631,9.777,61.576-6.317,71.354-35.946 C365.181,257.365,349.087,225.42,319.457,215.643z M321.725,261.071l-10.096-3.331c1.598-4.841,1.018-7.716-1.736-8.625 c-2.834-0.936-4.699-0.045-5.594,2.671c-0.637,1.929,0.236,4.704,2.619,8.326l2.41,3.807l3.947,5.296 c3.738,5.336,3.607,14.064-0.393,26.185c-4.143,12.556-10.365,17.462-18.67,14.722l-1.732,5.254l-5.844-1.929l2.395-7.26 c-0.658-1.047-1.068-2.252-1.23-3.614l-1.148,3.483l-10.094-3.331l9.641-29.221l10.096,3.331 c-2.131,6.454-1.504,10.238,1.883,11.355c3.029,1,5.18-0.428,6.453-4.285c1.182-3.58,0.115-7.424-3.199-11.529l-2.939-3.588 c-5.592-6.994-6.654-15.746-3.186-26.254c4.285-12.986,10.422-18.162,18.412-15.525l1.693-5.137l5.844,1.929l-2.064,6.258 c0.357,1.034,0.49,2.214,0.404,3.537l1.014-3.069l10.094,3.331L321.725,261.071z"
})))));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "rear_x5F__x24_"
}, React.createElement("g", {
  display: "none"
}, React.createElement("g", {
  display: "inline"
}, React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 301.753,
  cy: 269.292,
  r: 56.495
})), React.createElement("g", {
  display: "inline"
}, React.createElement("circle", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  cx: 301.753,
  cy: 269.292,
  r: 56.495
}))), React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  x1: 213.167,
  y1: 259.521,
  x2: 371.717,
  y2: 310.854
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "rear-bill-outline"
}, React.createElement("polygon", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 20,
  strokeMiterlimit: 10,
  points: "158.943,148.367 128.65,240.171  425.249,338.043 412.16,377.708 435.169,385.3 478.551,253.83  "
}), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M306.115,216.521c-32.557,0-58.948,26.392-58.948,58.948c0,0.681,0.028,1.354,0.051,2.029l38.33,12.706 l4.017-12.174l10.094,3.331c-2.129,6.454-1.502,10.239,1.883,11.356c3.029,1,5.182-0.428,6.455-4.285 c1.182-3.581,0.113-7.425-3.201-11.53l-2.939-3.588c-5.592-6.994-6.652-15.745-3.186-26.253 c4.285-12.987,10.422-18.163,18.412-15.526l1.695-5.136l5.844,1.929l-2.064,6.257c0.355,1.034,0.49,2.214,0.404,3.538l1.012-3.07 l10.096,3.331l-8.98,27.214l-10.094-3.331c1.596-4.841,1.018-7.716-1.736-8.625c-2.834-0.935-4.699-0.044-5.596,2.672 c-0.637,1.928,0.236,4.704,2.621,8.326l2.408,3.807l3.949,5.296c3.736,5.336,3.605,14.063-0.395,26.185 c-0.042,0.127-0.077,0.27-0.109,0.417l36.005,11.936c8.079-10.088,12.922-22.881,12.922-36.811 C365.063,242.913,338.671,216.521,306.115,216.521z"
}))), React.createElement("path", {
  fill: "none",
  stroke: "#F47C5E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  d: "M347.173,312.279"
}), React.createElement("path", {
  fill: "none",
  stroke: "#F47C5E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  d: "M247.218,277.498"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "front-bill"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M266.155,299.855c-29.63-9.776-61.575,6.317-71.353,35.946c-9.776,29.629,6.317,61.575,35.945,71.353 c29.631,9.777,61.576-6.317,71.354-35.946C311.879,341.578,295.785,309.633,266.155,299.855z M268.422,345.284l-10.094-3.331 c1.596-4.841,1.018-7.716-1.736-8.625c-2.834-0.935-4.699-0.044-5.596,2.672c-0.637,1.928,0.236,4.704,2.621,8.326l2.408,3.807 l3.949,5.296c3.736,5.336,3.605,14.063-0.395,26.185c-4.143,12.555-10.365,17.461-18.668,14.722l-1.734,5.254l-5.844-1.929 l2.396-7.261c-0.66-1.047-1.069-2.251-1.23-3.613l-1.148,3.482l-10.096-3.331l9.643-29.221l10.095,3.331 c-2.13,6.454-1.503,10.239,1.883,11.356c3.029,1,5.181-0.428,6.455-4.285c1.182-3.581,0.113-7.425-3.201-11.53l-2.939-3.588 c-5.592-6.994-6.653-15.745-3.187-26.253c4.286-12.987,10.422-18.163,18.413-15.526l1.695-5.136l5.844,1.929l-2.064,6.257 c0.355,1.034,0.49,2.214,0.404,3.538l1.012-3.07l10.096,3.331L268.422,345.284z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  d: "M266.155,299.855c-29.63-9.776-61.575,6.317-71.353,35.946 c-9.776,29.629,6.317,61.575,35.945,71.353c29.631,9.777,61.576-6.317,71.354-35.946 C311.879,341.578,295.785,309.633,266.155,299.855z M268.422,345.284l-10.094-3.331c1.596-4.841,1.018-7.716-1.736-8.625 c-2.834-0.935-4.699-0.044-5.596,2.672c-0.637,1.928,0.236,4.704,2.621,8.326l2.408,3.807l3.949,5.296 c3.736,5.336,3.605,14.063-0.395,26.185c-4.143,12.555-10.365,17.461-18.668,14.722l-1.734,5.254l-5.844-1.929l2.396-7.261 c-0.66-1.047-1.069-2.251-1.23-3.613l-1.148,3.482l-10.096-3.331l9.643-29.221l10.095,3.331 c-2.13,6.454-1.503,10.239,1.883,11.356c3.029,1,5.181-0.428,6.455-4.285c1.182-3.581,0.113-7.425-3.201-11.53l-2.939-3.588 c-5.592-6.994-6.653-15.745-3.187-26.253c4.286-12.987,10.422-18.163,18.413-15.526l1.695-5.136l5.844,1.929l-2.064,6.257 c0.355,1.034,0.49,2.214,0.404,3.538l1.012-3.07l10.096,3.331L268.422,345.284z"
}))), React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 20,
  strokeMiterlimit: 10,
  d: "M105.642,232.579L62.26,364.05l35.706,11.782 c7.436-11.774,20.555-19.602,35.51-19.602c23.185,0,41.979,18.795,41.979,41.979c0,1.061-0.053,2.108-0.13,3.148l206.543,68.154 l43.382-131.47L105.642,232.579z"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "coin"
}, React.createElement("circle", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 20,
  strokeMiterlimit: 10,
  cx: 133.475,
  cy: 399.997,
  r: 41.979
}));

var SvgFraudV2 = function SvgFraudV2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "496px",
    height: "494.043px",
    viewBox: "0 0 496 494.043",
    enableBackground: "new 0 0 496 494.043",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFraudV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fraud_v2.b3099cdd.svg";
export { ForwardRef as ReactComponent };